(function($, undefined) {
	'use strict';
	var volume = 0.5;
	var fileType;

	var togglePopupAudio = function() {
		var t = $(this);
		var ctn = t.closest('.demo-js');
		var popupId = t.attr('data-id');
		var popup = $('.audition-single-artist-ctn').length > 0 ? $('.audition-single-artist-ctn:visible .popup[data-id=' + popupId + ']') : $('.popup[data-id=' + popupId + ']');
		var openId = $('.demo-player-popup.open').attr('data-id');
		var delay = 0;

		if ($('.demo-player-popup.open').length > 0 && $('.demo-player-popup.open').attr('data-id') !== popupId) {
			var openPlayer = $('.popup[data-id=' + openId + ']');

			delay = 300;

			openPlayer.find('audio').trigger('pause');
			openPlayer.find('video').trigger('pause');
			openPlayer.removeClass('open');
			$('.demo-js[data-id=' + openId + ']').removeClass('playing');
		}

		if ($('.demo-js.playing').length > 0 && $('.demo-js.playing').attr('data-popup-id') !== popupId) {
			var playingId = $('.demo-js.playing').attr('data-popup-id');
			var player = $('.popup[data-id=' + playingId + ']');
			
			player.find('audio').trigger('pause');
			$('.demo-js[data-id=' + openId + ']').removeClass('playing');
		}

		setTimeout(function() {
			var playerCtn = $('.audition-single-artist-ctn').length > 0 ? $('.audition-single-artist-ctn:visible .popup[data-id="'+popupId+'"] .player-container') : $('.popup[data-id="'+popupId+'"] .player-container')
			var mediaType = playerCtn.attr('data-type');

			if (!!document.createElement(mediaType).canPlayType && !playerCtn.hasClass('is-init')) {
				initPlayer(playerCtn, function() {
					popup.removeClass('is-processing');
				});
				ctn.toggleClass('playing');
				popup.addClass('open is-processing');
//                if (!(navigator.userAgent.indexOf('Safari') !== -1 &&
//                        navigator.userAgent.indexOf('Chrome') === -1 &&
//                        navigator.userAgent.indexOf('CriOS/') === -1)) {
                    playerCtn.find('.play-audio-btn').trigger('click');
//                }
            } else if (!!document.createElement(mediaType).canPlayType) {
                ctn.toggleClass('playing');
//                if (!(navigator.userAgent.indexOf('Safari') !== -1 &&
//                        navigator.userAgent.indexOf('Chrome') === -1 &&
//                        navigator.userAgent.indexOf('CriOS/') === -1)) {
                    playerCtn.find('.play-audio-btn').trigger('click');
//                }
				popup.addClass('open');
			}
		}, delay);
	};

	var initPlayer = function(t, callback) {
		var path = t.attr('data-sound');
		var ext = t.attr('data-ext');
		var fileType = t.attr('data-type');
		var gendataId = t.attr('data-demoid');
		
		if (ext !== '') {
			initPlayerComponents(t, callback);
		} else {
			//Check for ext
			checkIfFileExistWithExt('mp3');
			checkIfFileExistWithExt('m4a');
			checkIfFileExistWithExt('mp4');
			checkIfFileExistWithExt('webm');
			checkIfFileExistWithExt('mov');
			checkIfFileExistWithExt('wav');
		}
		
		function checkIfFileExistWithExt(currExt) {
			$.ajax({
				url: path + currExt,
				method: 'HEAD',
				error: function(jqXHR, textStatus, errorThrown) {
					// console.log('Not found : ' + path + currExt);
					// console.log(jqXHR);
					// console.log(errorThrown);
				},
				success: function() {
					// console.log('File IS found : ' + path + currExt);
					path = path + currExt;
					ext = currExt;
					initPlayerComponents(t, callback);
					
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: gendataId,
							field18: currExt,
							ajax: true
						},
						success: function (response) {
							// console.log('Demo ext change : ' + response);
						}
					});
				}
			});
		}
		
		function initPlayerComponents(t, callback) {
			var media;
			var timeleft = $('.time-left', t);
			var slider = $('.time .slider', t);
			var progressBar = $('.time .progress', t);
			var volumeSlider = $('.volume .slider', t);
			var volumeBar = $('.volume .progress', t);
			var duration;
			var animSlider;
			var animProgressBar;
			var id = t.closest('.popup').attr('data-id');
			var demoCtn = $('.demo-js[data-popup-id=' + id + ']');
			var count = $('.demo-js[data-popup-id='+ id + '] .listen-count, .profile-top-right-ctn .listen-count');

			if (t.attr('data-type') === 'video') {
				media = document.createElement("video");
				media.setAttribute("src", path);
			} else {
				media = new Audio(path);
			}
			
			if (demoCtn.length === 0) {
				demoCtn = $('.demo-js[data-id=' + id + ']');
			}
			
			//console.log('audio-init id: ' + t.attr('data-sound'));
			media.volume = volume;
			volumeSlider.val(volume);
			volumeBar.css('width', (volume * 100) + '%');

			if (t.closest('.popup-inner').find('.media-ctn').length > 0) {
				t.closest('.popup-inner').find('.media-ctn').append(media);
			} else {
				t.append(media);
			}

			$(media).on('loadedmetadata', function() {
				slider.attr('max', media.duration);

				if (t.closest('.is-processing').length > 0) {
					t.closest('.is-processing').removeClass('is-processing');
				}

				if (t.hasClass('playing')) {
					animSlider = $({ val: media.currentTime }).animate({ val: media.duration }, {
						duration: ((media.duration - media.currentTime) * 1000),
						easing: 'linear',
						step: function(val) {
							slider.val(val);
						}
					});
					animProgressBar = $({ width: (media.currentTime / media.duration * 100) }).animate({ width: 100 }, {
						duration: ((media.duration - media.currentTime) * 1000),
						easing: 'linear',
						step: function(val) {
							progressBar.css('width', val + '%');
						}
					});
				}
			});

			$(media).bind('timeupdate', function() {
				var rem = parseInt(media.duration - media.currentTime, 10),
				mins = Math.floor(rem/60,10),
				secs = rem - mins*60;

				timeleft.text('-' + mins + ':' + (secs > 9 ? secs : '0' + secs));
			});

			$(media).bind('play',function() {
				// console.log(media.currentTime);
				if (media.currentTime < 0.01 && !t.hasClass('no-count')) {
					var newCount = parseInt(count.html()) + 1;
					// console.log(gendataId);
					// console.log(newCount);

					// ADD TO PLAY COUNTER
					$.ajax({
						url: '/action/vcUpdateCounter',
						cache: false,
						method: 'POST',
						data: {
							id: gendataId,
							field: "field13",
							ajax: true
						},
						success: function (response) {
							// console.log('add count: ' + response);
							count.html(response);
						}
					});
				}

				animSlider = $({ val: media.currentTime }).animate({ val: media.duration }, {
					duration: ((media.duration - media.currentTime) * 1000),
					easing: 'linear',
					step: function(val) {
						slider.val(val);
					}
				});
				animProgressBar = $({ width: (media.currentTime / media.duration * 100) }).animate({ width: 100 }, {
					duration: ((media.duration - media.currentTime) * 1000),
					easing: 'linear',
					step: function(val) {
						progressBar.css('width', val + '%');
					}
				});
				t.addClass('playing');
				demoCtn.addClass('playing');
			}).bind('pause ended', function() {
				t.removeClass('playing');
				if (animSlider !== undefined) {
					animSlider.stop();
					animProgressBar.stop();
					demoCtn.removeClass('playing');
				}
			});

			$(media).on('ended', function() {
				slider.val(0);
				progressBar.css('width', 0);
				demoCtn.removeClass('playing');
				// t.closest('.popup').removeClass('open');
			});

			$(".play-audio-btn", t).click(function() {
				if (media.paused) { media.play(); }
				else { media.pause(); }
			});

			// **** tester waiting et playing, ajuster animations en consequence

			// SLIDERS

			slider.on('input', function() {
				if (animSlider !== undefined) {
					animSlider.stop();
					animProgressBar.stop();
				}
				media.currentTime = slider.val();
				progressBar.css('width', (media.currentTime / media.duration * 100) + '%');
			});

			slider.change(function() {
				media.currentTime = slider.val();
				progressBar.css('width', (media.currentTime / media.duration * 100) + '%');
				
				if (!media.paused) {	
					animSlider = $({ val: media.currentTime }).animate({ val: media.duration }, {
						duration: ((media.duration - media.currentTime) * 1000),
						easing: 'linear',
						step: function(val) {
							slider.val(val);
						}
					});
					animProgressBar = $({ width: (media.currentTime / media.duration * 100) }).animate({ width: 100 }, {
						duration: ((media.duration - media.currentTime) * 1000),
						easing: 'linear',
						step: function(val) {
							progressBar.css('width', val + '%');
						}
					});
				}
			});

			volumeSlider.on('input', function() {
				volume = volumeSlider.val();
				media.volume = volume;
				volumeBar.css('width', (volume * 100) + '%');
			});

			volumeSlider.change(function() {
				volume = volumeSlider.val();
				media.volume = volume;
				volumeBar.css('width', (volume * 100) + '%');
			});

			if (callback) {
				$(media).on('loadedmetadata', function() {
					callback();
				});
			}

			t.addClass('is-init');
		}
	};

	var init = function() {
		$('.player-container.initOnInit').each(function () {
			initPlayer($(this));
		});
		
		$('body').on('click', '.play-audio-btn.open-player', togglePopupAudio);

		$('body').on('click', '.demo-player-popup.open .js-popup-close-btn', function() {
			var mediaType = $('.demo-player-popup.open').find('.player-container').attr('data-type');

			$('.demo-player-popup.open').find(mediaType).trigger('pause');
		});
	};
	
	$(window).ready(init);

	Fw.component.export('player', {
		togglePopupAudio: togglePopupAudio
	});

})(jQuery);

